import { useMutation } from "@tanstack/react-query";
import {
  unitUpdate,
  UnitUpdateParams,
} from "common/api/citajteo/dl_unit/dl_unit_edit";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnitUpdateParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitUpdate = (hookParams?: UseUnitUpdateParams) => {
  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: unitUpdateMutate } = useMutation({
    mutationFn: async (params: {
      id: string;
      updatePayload: UnitUpdateParams;
    }) => {
      const response = await unitUpdate(params.id, params.updatePayload);

      if (!response) {
        throw new Error("unitUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitUpdateMutate };
};
